import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const CupIntake2 = createIcon({
  Root: Svg,
  viewBox: "0 0 48 62",
  path: (
    <>
      <Path
        d="M10.7869 60.3083C9.05305 60.3083 7.60504 58.9868 7.44698 57.2602L2.69489 5.35101C2.51502 3.38621 4.06176 1.69141 6.03477 1.69141H41.9349C43.9162 1.69141 45.4657 3.3999 45.2728 5.37183L40.194 57.281C40.0259 58.9986 38.5819 60.3083 36.8561 60.3083H10.7869Z"
        fill="white"
        stroke="#4767CA"
        strokeWidth="2.5"
        strokeMiterlimit="10"
      />
      <Path
        d="M43.1506 27.09C43.1506 27.09 35.2523 34.5774 25.2662 28.7417C15.2801 22.9061 6.98772 23.7277 4.16211 27.2241L7.72557 60.3098H39.9057L43.159 27.0816L43.1506 27.09Z"
        fill="#A0DDF9"
      />
      <Path
        d="M10.7869 60.3083C9.05305 60.3083 7.60504 58.9868 7.44698 57.2602L2.69489 5.35101C2.51502 3.38621 4.06176 1.69141 6.03477 1.69141H41.9349C43.9162 1.69141 45.4657 3.3999 45.2728 5.37183L40.194 57.281C40.0259 58.9986 38.5819 60.3083 36.8561 60.3083H10.7869Z"
        stroke="#4767CA"
        strokeWidth="2.5"
        strokeMiterlimit="10"
      />
    </>
  ),
});

export { CupIntake2 };
